import React from 'react';
import SobrePlataforma from './SobrePlataforma/SobrePlataforma.jsx';
import Planos from './Planos/Planos.jsx';
import FormPlanos from './FormPlanos/FormPlanos.jsx';

const Produtos = () => {

    window.scrollTo(0, 0);
    return (
        <>
            <div className="view-produtos">
               <SobrePlataforma></SobrePlataforma>
               <Planos></Planos>
               <FormPlanos></FormPlanos>
            </div>
        </>

    )
}

export default Produtos;